// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__rYjQA","content":"style_content__3zkxY"};